export interface Modality {
    id: number
    name: string
}

export const defaultModality: Modality = {
    id: 0
    , name: ''
}